import * as urls from "utils/contants/urls";
import { ItemMenu, LabelItem, MenuBody } from "./MenuStyle";
import React, { useState, useEffect } from "react";
import { managers, home } from "assets/icons/icons";

import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { push } from "connected-react-router";

const Menu = ({ goTo }) => {
  const [selected, setSelected] = useState({
    users: false,
    home: false,
    Settings: false,
    Profiles: false,
    modules: false,
  });

  useEffect(() => {
    updateRouter({
      users: false,
      home: false,
      Settings: false,
      Profiles: true,
      modules: false,
    });
  }, []);
  const updateRouter = (newFocus) => {
    setSelected({ ...newFocus });
    if (newFocus.home) goTo(urls.Profiles);
    if (newFocus.users) goTo(urls.USERS);
    if (newFocus.Settings) goTo(urls.Settings);
    if (newFocus.Profiles) goTo(urls.Profiles);
    if (newFocus.modules) goTo(urls.APP);
  };

  return (
    <MenuBody>
      <ItemMenu
        selected={selected.Profiles}
        onClick={() =>
          updateRouter({
            users: false,
            home: false,
            Settings: false,
            Profiles: true,
            modules: false,
          })
        }
      >
        {managers()}
        <LabelItem>
          <FormattedMessage id="menuManagerBar.profiles" />
        </LabelItem>
      </ItemMenu>

      <ItemMenu
        selected={selected.modules}
        onClick={() =>
          updateRouter({
            users: false,
            home: false,
            Settings: false,
            Profiles: false,
            modules: true,
          })
        }
      >
        {home()}
        <LabelItem>
          <FormattedMessage id="menuManagerBar.modules" />
        </LabelItem>
      </ItemMenu>
    </MenuBody>
  );
};

const MapStateToProps = (state) => ({});
const MapDispatchToProps = (dispatch) => ({
  goTo: (route) => dispatch(push(route)),
});

export default connect(MapStateToProps, MapDispatchToProps)(Menu);
